import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { SxProps, Theme } from "@mui/material";
import { useIsMobile } from "../hooks";
import infoBulbImg from "../assets/info-bulb.webp";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const InfoBoxStyle: Record<string, SxProps<Theme>> = {
    container: {
        // flexGrow: 1,
        // marginTop: "40px",
        marginLeft: "0px",
        marginRight: "0px",
        paddingLeft: "40px",
        paddingBottom: "20px",
        borderBottom: "2px solid #81BC00",
        //borderLeft: "3px solid #81BC00",
        borderBottomLeftRadius: "20px",
        position: "relative",
        // border: "1px solid"
    },
    containerMobile: {
        flexGrow: 1,
        // marginTop: "40px",
        // marginLeft: "30px",
        // marginRight: "30px",
        paddingLeft: "40px",
        paddingBottom: "20px",
        borderBottom: "2px solid #81BC00",
        //borderLeft: "3px solid #81BC00",
        borderBottomLeftRadius: "20px",
        position: "relative",
    },

    infoText: {
        fontSize: "18px",
        textAlign: "left",
    },
    infoTextMobile: {
        fontSize: "16px",
        textAlign: "left",
    },
    borderLeft: {
        position: "absolute",
        left: "-2px",
        bottom: "00px",
        height: "35%",
        width: "20px",
        borderLeft: "2px solid #81BC00",
        borderBottomLeftRadius: "20px",
    },
    infoImage: {
        position: "absolute",
        left: "-20px",
        top: "25%",
        img: {
            height: "40px",
            width: "auto",
        },
    },
};

export default function InfoBox() {
    const { isMobile } = useIsMobile();
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <Box sx={isMobile ? InfoBoxStyle.containerMobile : InfoBoxStyle.container}>
            <Box sx={InfoBoxStyle.borderLeft} />
            <Box sx={InfoBoxStyle.infoImage}>
                <img src={infoBulbImg} />
            </Box>
            <Typography sx={InfoBoxStyle.infoText}>
                {isMobile ? t("infobox.1.mobile") : t("infobox.1")}{" "}
                <a onClick={() => {navigate("/contact")}} style={{cursor: "pointer", textDecoration: "underline"}}>
                    {t("infobox.2")}
                </a>
                {" "}
                {t("infobox.3")}
            </Typography>
        </Box>
    );
}
